const COMPONENT_NAME = "pack-selector";
const CLASS_SELECTOR = ".PackSelector";
const CHILD_SELECTOR = ".PackSelectorItem";
const CSS_ACTIVE = "is-active";
const instances = [];

function initialize(element, PageComponents) {
    let activeSelectorIndex = 0;
    const targetSets = [];
    const childElements = element.querySelectorAll(CHILD_SELECTOR);
    const selectorTarget = element.getAttribute("data-target");
    if (selectorTarget) {
        const selectorTokens = selectorTarget.split(',');
        for(const selectorToken of selectorTokens) {
            const targetElements = document.querySelectorAll(selectorToken);
            if (!targetElements) {
                console.error(`Error: could not find content target "${selectorTarget}" for pack selector`, targetElements);
                return;
            }

            // if (targetElements.length !== childElements.length) {
            //     console.error(`Error: target element mismatch (${targetElements.length} vs ${childElements.length}) for pack selector`, targetElements);
            //     return;
            // }
            targetSets.push(targetElements);
        }

        function syncSelectors(index) {
            function setIndexActive(element, i) {
                element.classList.toggle(CSS_ACTIVE, i === index);
            }

            childElements.forEach(setIndexActive);
        }

        function syncContent(index) {
            targetSets.forEach((targetElements) => {
                targetElements.forEach((content, i) => {
                    content.classList.toggle(CSS_ACTIVE, i === index);
                });
            });
        }

        function sync(index) {
            syncSelectors(index);
            syncContent(index);
            activeSelectorIndex = index;
        }

        childElements.forEach((selector, index) => {
            if (selector.classList.contains(CSS_ACTIVE)) {
                activeSelectorIndex = index;
            }

            // Add item click handler
            selector.addEventListener('click', (e) => {
                e.stopPropagation();
                sync(index);
            });
        });
        if (activeSelectorIndex > -1) sync(activeSelectorIndex);

        instances.push({
            childElements,
            targetSets,
            sync
        });
    }
}

module.exports = {
    name: COMPONENT_NAME,
    instances,
    initialize
};
